import { render, staticRenderFns } from "./OgTable.vue?vue&type=template&id=d3b45174&"
import script from "./OgTable.vue?vue&type=script&lang=js&"
export * from "./OgTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports